import Swal from 'sweetalert2';

function alertNotify(icon = 'info', title = null, message = null, timer = 5000) {
  Swal.fire({
    icon: icon,
    title: title,
    html: message,
    toast: true,
    position: 'top-end',
    color: 'black',
    showCloseButton: true,
    showConfirmButton: false,
    timer: timer,
    timerProgressBar: true,
    customClass: {
      title: 'swal2-title-notifcation'
    },
    didOpen: toast => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });
}
window.alertNotify = alertNotify;
